export const saEvent = (eventName) => {
    
  if (window && window.sa_event) return window.sa_event(eventName);
};